import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AssetVisjs} from 'src/app/common/models/ai-reports/shared/assets';
import {AbstractAssetComponent} from '../abstract-asset.component';
import {VisjsGraphComponent} from './visjs-graph/visjs-graph.component';

@Component({
  selector: 'app-asset-visjs',
  standalone: true,
  imports: [VisjsGraphComponent],
  templateUrl: './asset-visjs.component.html',
  styleUrl: './asset-visjs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetVisjsComponent extends AbstractAssetComponent<AssetVisjs> {
}
